import React, { useEffect, useState } from "react";
import { FileText, Mail, CheckCircle2 } from "lucide-react";
import Skeleton from "components/ui/Skeleton";
import apiEmailManagement from "../../../api";

const StepTemplate = ({ selectedTemplate, setSelectedTemplate }) => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    apiEmailManagement
      .getAllEmailTemplates({ mailing_for: "MARKETING", limit: 100, skip: 0 })
      .then((res) => {
        if (!cancelled) setTemplates(res.data?.data || []);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  if (loading) {
    return <Skeleton.Rows rows={4} />;
  }

  if (templates.length === 0) {
    return (
      <p className="text-sm text-text_secondary">
        No active marketing templates found. Create one under Email Templates first.
      </p>
    );
  }

  return (
    <div className="max-h-[400px] overflow-y-auto space-y-2">
      {templates.map((t) => {
        const isSelected = selectedTemplate?.id === t.id;
        return (
          <button
            type="button"
            key={t.id}
            onClick={() => setSelectedTemplate(t)}
            className={`w-full text-left flex items-start gap-3 rounded-lg border p-3 ${
              isSelected ? "border-primary/50 bg-primary/[0.04]" : "border-border bg-surface"
            }`}
          >
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-primary/20 bg-primary_tint">
              <FileText size={16} className="text-primary" />
            </div>
            <div className="min-w-0 flex-1">
              <div className="text-xs font-semibold text-text_primary truncate">{t.template_name}</div>
              <div className="flex items-center gap-1 text-[11px] text-text_muted truncate mt-0.5">
                <Mail size={10} className="flex-shrink-0" />
                {t.subject}
              </div>
            </div>
            {isSelected && <CheckCircle2 size={16} className="text-primary flex-shrink-0 mt-1" />}
          </button>
        );
      })}
    </div>
  );
};

export default StepTemplate;
